
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("g8AHf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $152525979e36cdda$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //French (France)
var $152525979e36cdda$export$2e2bcd8739ae039 = {
    'ai-floating-context-menu.ai-dynamic-surface.rovo-panel-title': 'Rovo',
    'ai-smart-button.ai-actions.actions.section.text': 'Actions',
    'ai-smart-button.ai-actions.give-feedback-action.title': 'Envoyer un feedback',
    'ai-smart-button.ai-actions.help.section.text': 'Aide',
    'ai-smart-button.ai-actions.input.link-picker-button-label': 'Lier',
    'ai-smart-button.ai-actions.input.mention-button-label': 'Mentionner',
    'ai-smart-button.ai-actions.input.placeholder': "\xc9crivez ce dont vous avez besoin",
    'ai-smart-button.ai-actions.input.send-button-label': 'Envoyer',
    'ai-smart-button.ai-actions.item.betaLozenge': "B\xcaTA",
    'ai-smart-button.ai-actions.item.newLozenge': 'NOUVEAU',
    'ai-smart-button.ai-actions.rovo-agents.add-icon-label': "Ajouter une ic\xf4ne",
    'ai-smart-button.ai-actions.rovo-agents.automation-icon-label': "Ic\xf4ne d'automatisation",
    'ai-smart-button.ai-actions.rovo-agents.automations.text': 'Automatisations',
    'ai-smart-button.ai-actions.rovo-agents.create-agent.text': 'Parcourir les agents',
    'ai-smart-button.ai-actions.rovo-agents.create-automation.text': "Cr\xe9er une automatisation",
    'ai-smart-button.ai-actions.rovo-agents.section.text': 'Studio',
    'ai-smart-button.ai-dynamic-surface.components.greeting.intro-second-line': "Comment puis-je vous aider\xa0?",
    'ai-smart-button.ai-dynamic-surface.components.greeting.intro-text-headline': 'Bonjour {name},',
    'ai-smart-button.ai-proactive-nudge.dismiss': 'Ignorer',
    'ai-smart-button.feedback-action.ask-question-option': 'Poser une question',
    'ai-smart-button.feedback-action.cancel-button-label': 'Annuler',
    'ai-smart-button.feedback-action.choose-feedback-option': "Choisissez un \xe9l\xe9ment",
    'ai-smart-button.feedback-action.feedback-entry-bug-heading': "D\xe9crivez le bug ou le probl\xe8me",
    'ai-smart-button.feedback-action.feedback-entry-comment-heading': 'Dites-nous tout',
    'ai-smart-button.feedback-action.feedback-entry-question-heading': "Que souhaitez-vous savoir\xa0?",
    'ai-smart-button.feedback-action.feedback-entry-suggest-heading': "Dites-nous ce que vous aimeriez am\xe9liorer",
    'ai-smart-button.feedback-action.leave-comment-option': 'Laisser un commentaire',
    'ai-smart-button.feedback-action.report-bug-option': 'Signaler un bug',
    'ai-smart-button.feedback-action.research-participation-message': "J'aimerais participer \xe0 la recherche produit",
    'ai-smart-button.feedback-action.select-feedback-heading': "S\xe9lectionner le sujet de votre feedback",
    'ai-smart-button.feedback-action.submit-button-label': 'Envoyer des commentaires',
    'ai-smart-button.feedback-action.suggest-improvement-option': "Sugg\xe9rer une am\xe9lioration",
    'ai-smart-button.feedback-action.title': 'Envoyer un feedback',
    'ai-smart-button.feedback-item.icon-label': "Ic\xf4ne de feedback",
    'ai-smart-button.reference.close-button-label': 'Fermer',
    'quick-summary.feedback.summary.placeholder': "\xc0 quels niveaux Atlassian\xa0Intelligence est-il performant\xa0? Que pourrions-nous am\xe9liorer\xa0?",
    'quick-summary.feedback.title': "Aidez-nous \xe0 am\xe9liorer Atlassian\xa0Intelligence"
};

});


//# sourceMappingURL=fr.cdbaf42e.js.map
